module.exports = __webpack_public_path__ + "img/CRIT_AIR_3.e87a58bf.png";